import React, { useEffect, useState } from 'react'
import { useWindowSize } from 'react-use'
import Confetti from 'react-confetti'

import { useAudio } from 'utils/audioContext';


function Complete({ questionData, questionVariables, questionText, questionStatus, onLeave }) {

    const { play } = useAudio();

    const [animationState, setAnimationState] = useState(0);

    useEffect(() => {
        if (animationState) return; // Prevent re-animation on re-render

        let animTimeout = setTimeout(() => {
            setAnimationState(1);
        }, 10);

        play('complete.mp3');

        return () => clearTimeout(animTimeout);
    }, []);

    useEffect(() => {
        onLeave(() => {
            setAnimationState(2);
        });
    }, [onLeave]);

    const { width, height } = useWindowSize()

    return (
        <div className="h-full w-full flex items-center justify-center">
            <div className='absolute inset-0' style={{ opacity: animationState === 1 ? 1 : 0, transition: `opacity ${animationState === 2 ? 0.2 : 0.5}s ease`, background: `linear-gradient(to top, color-mix(in srgb, var(--primary-dark) 50%, transparent), transparent)` }}></div>
            <div className='flex flex-col items-center justify-center gap-2 text-center' style={{ transform: `scale(${animationState === 1 ? 1 : 0.3})`, transition: `transform .35s ease` }}>
                <h1 className='text-5xl font-bold text-white'>{questionText.includes(" Test") ? "Unit" : "Lesson"} Complete!</h1>
                <h1 className='text-2xl text-primary font-medium'>{questionText.includes(" Test") ? questionText.replace(" Test", "") : questionText}</h1>
            </div>
            {animationState === 1 && <Confetti
                width={width}
                height={(height - 100)}
                recycle={false}
                numberOfPieces={questionText.includes(" Test") ? 200 : 50}
                colors={['white']}
                initialVelocityY={{ min: -1, max: -30 }}
                initialVelocityX={{ min: -19, max: 19 }}
                tweenDuration={10}
                gravity={0.2}
                confettiSource={{ x: width / 2 - 100, y: height - 100, w: 200, h: 50 }}
                opacity={0.5}
                style={{
                    maxHeight: "100%", minWidth: "100%"
                }}
            />}
        </div>

    )
}

export default Complete; 